<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`transaction/invoice-v2/${inputs.invoice_id}/approve-payment-received`"
      >
        <div class="form-group row align-items-center">
          <label for="inputs_payment_received" class="col-sm-3 mb-0">
            Payment Received
          </label>
          <app-input
            id="inputs_payment_received"
            class="col-sm-9"
			      v-model="inputs.payment_received"
            type="number"
            placeholder="Payment Received"
            required
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_payment_date" class="col-sm-3 mb-0">
            Payment Date
          </label>
          <app-input
            id="inputs_payment_date"
            class="col-sm-9"
			      v-model="inputs.payment_date"
            type="date"
            placeholder="Payment Date"
            required
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_receipt_date" class="col-sm-3 mb-0">
            Receipt Date
          </label>
          <app-input
            id="inputs_receipt_date"
            class="col-sm-9"
			      v-model="inputs.receipt_date"
            type="date"
            placeholder="Receipt Date"
            required
          />
        </div>
        <div class="form-group row align-items-center">
          <div class="col-md-12">
            <br>
            <br>
            <br>
            <br>
            <br>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-md-12">
            <br>
            <br>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { InvoiceHistoryApproveFormMixin } from "./InvoiceHistoryApproveFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
  name: "InvoiceHistoryApproveForm",
  mixins: [InvoiceHistoryApproveFormMixin,ModalMixin, UserMixin],
  props: {
    tableId: String,
    formId: String,
    confirmInvoiceId: {
        type: Number,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
		invoice_id: this.confirmInvoiceId,
        payment_received: "",
      },
      modalId: this.formId,
      modalTitle: "Approval Invoice",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = 'Approval Invoice';
      this.preloader = true;
    }
  },
  methods: {
   
    submit() {
      this.save(this.inputs);
    },
    beforeSubmit() {
        this.preloader = true;
    },
    afterSuccess(res) {
        this.$toastr.s(res.data.data);
        this.$hub.$emit("reload-" + this.tableId);
        this.preloader = false;
    },
    afterError(res) {
        if (res === undefined) {
            return;
        } else if (res.data === undefined) {
            return;
        } else if (res.data.message === undefined) {
            return;
        } else {
            this.$toastr.e(res.data.message);
        }
    },
    afterSuccessFromGetEditData(response) {
        this.inputs = response.data;
       
        this.preloader = false;
    },
   
  },
};
</script>
